<template>
  <v-dialog v-model="dialog" width="600" class="semi-rounded">
    <v-card color="white" class="px-8 py-12 semi-rounded">
      <v-layout
        class="flex-column justify-center align-center primary--text title text-center"
      >
        <v-icon
          v-if="!hideIcon"
          color="primary"
          class="mb-4"
          style="font-size: 4rem"
          >{{ dialogData.icon ? dialogData.icon : "info" }}</v-icon
        >
        <span v-if="dialogData.primary_text" class="py-6">{{
          dialogData.primary_text
        }}</span>
        <span v-if="dialogData.secondary_text" class="font-weight-bold">{{
          dialogData.secondary_text
        }}</span>
        <v-btn
          class="py-8 px-10 mt-6 textOverSecondary--text semi-rounded"
          color="primary"
          x-large
          @click="dialog = false"
        >
          {{ $t("actions.ok") }}
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["dialogData", "hideIcon"],
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
